import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
/**
 * Inline widget shown inside the login / sign-up / forgot-password modals.
 *
 * Visual states
 * ─────────────
 *  solving  → spinner + "Verifying security…"
 *  solved   → ✓ checkmark + "Security check passed"
 *  error    → ✗ icon + error message + Retry button
 */
export default class PowCaptchaWidget extends Component {
  oncreate(vnode) {
    super.oncreate(vnode);
    // Start solving as soon as the widget is mounted.
    this.attrs.state.start();
  }
  view() {
    const state = this.attrs.state;
    const status = state.getStatus();
    const isSolving = status === 'loading' || status === 'solving';

    // All three inner panels are always rendered so the container keeps a
    // fixed height throughout every state transition.  The active panel is
    // revealed with CSS opacity (see forum.less), which produces a smooth
    // cross-fade without any layout jump in the modal.
    return m("div", {
      className: "PowCaptchaWidget PowCaptchaWidget--".concat(status)
    }, m("div", {
      className: "PowCaptchaWidget-inner PowCaptchaWidget-solving".concat(isSolving ? ' is-visible' : '')
    }, m(LoadingIndicator, {
      size: "small"
    }), m("span", {
      className: "PowCaptchaWidget-label"
    }, app.translator.trans('peopleinside-powcaptcha.forum.solving'))), m("div", {
      className: "PowCaptchaWidget-inner PowCaptchaWidget-solved".concat(status === 'solved' ? ' is-visible' : '')
    }, m("span", {
      className: "icon fas fa-check-circle",
      "aria-hidden": "true"
    }), m("span", {
      className: "PowCaptchaWidget-label"
    }, app.translator.trans('peopleinside-powcaptcha.forum.verified'))), m("div", {
      className: "PowCaptchaWidget-inner PowCaptchaWidget-error".concat(status === 'error' ? ' is-visible' : '')
    }, m("span", {
      className: "icon fas fa-times-circle",
      "aria-hidden": "true"
    }), m("span", {
      className: "PowCaptchaWidget-label"
    }, app.translator.trans('peopleinside-powcaptcha.forum.error')), m(Button, {
      className: "Button Button--text",
      onclick: () => state.retry()
    }, app.translator.trans('peopleinside-powcaptcha.forum.retry'))));
  }
}
flarum.reg.add('peopleinside-fla-powcaptcha', 'forum/components/PowCaptchaWidget', PowCaptchaWidget);